import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=10ae4b71&"
import script from "./IconCross.vue?vue&type=script&lang=ts&"
export * from "./IconCross.vue?vue&type=script&lang=ts&"
import style0 from "./IconCross.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports